// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.SignIn_container__raUxh {
  max-width: 420px;
  margin: 40px auto;
  background: #fff;
  padding: 32px 36px 40px;
  border-radius: 16px;
  box-shadow: 0 4px 12px rgba(0,0,0,0.08);
  border: 1px solid #e5e7eb;
}
.SignIn_title__F6fjN {
  margin: 0 0 24px;
  font-size: 24px;
  font-weight: 600;
  text-align: center;
}
.SignIn_form__8nGAr { display: flex; flex-direction: column; gap: 18px; }
.SignIn_label__y2V0H { font-size: 14px; font-weight: 500; display: flex; flex-direction: column; gap: 6px; }
.SignIn_input__HT8-i {
  height: 44px;
  padding: 0 14px;
  border: 1px solid #cbd5e1;
  border-radius: 10px;
  font-size: 15px;
  transition: border-color .2s, box-shadow .2s;
}
.SignIn_input__HT8-i:focus {
  outline: none;
  border-color: #2563eb;
  box-shadow: 0 0 0 3px rgba(37,99,235,0.25);
}
.SignIn_passwordRow__erscc { display: flex; align-items: center; }
.SignIn_toggleButton__V\\+LGd {
  margin-left: 8px;
  height: 40px;
  width: 44px;
  border: 1px solid #cbd5e1;
  border-radius: 10px;
  background: #f1f5f9;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 18px;
}
.SignIn_toggleButton__V\\+LGd:hover { background:#e2e8f0; }
.SignIn_error__RLtwJ { color: #dc2626; font-size: 13px; }
.SignIn_submit__U1zNo {
  height: 48px;
  background: linear-gradient(90deg,#2563eb,#1d4ed8);
  color: #fff;
  font-weight: 600;
  font-size: 15px;
  border: none;
  border-radius: 12px;
  cursor: pointer;
  box-shadow: 0 4px 10px -2px rgba(0,0,0,0.15);
  transition: transform .15s, box-shadow .2s;
}
.SignIn_submit__U1zNo:hover { box-shadow: 0 6px 16px -2px rgba(0,0,0,0.2); }
.SignIn_submit__U1zNo:active { transform: translateY(2px); box-shadow:0 3px 8px -1px rgba(0,0,0,0.25); }
.SignIn_links__iXKjQ { margin-top: 8px; display:flex; justify-content: space-between; font-size: 13px; }
.SignIn_links__iXKjQ a { color:#2563eb; text-decoration:none; }
.SignIn_links__iXKjQ a:hover { text-decoration:underline; }
`, "",{"version":3,"sources":["webpack://./src/Page/Login/SignIn/SignIn.module.css"],"names":[],"mappings":"AAAA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;EACnB,uCAAuC;EACvC,yBAAyB;AAC3B;AACA;EACE,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,kBAAkB;AACpB;AACA,sBAAQ,aAAa,EAAE,sBAAsB,EAAE,SAAS,EAAE;AAC1D,uBAAS,eAAe,EAAE,gBAAgB,EAAE,aAAa,EAAE,sBAAsB,EAAE,QAAQ,EAAE;AAC7F;EACE,YAAY;EACZ,eAAe;EACf,yBAAyB;EACzB,mBAAmB;EACnB,eAAe;EACf,4CAA4C;AAC9C;AACA;EACE,aAAa;EACb,qBAAqB;EACrB,0CAA0C;AAC5C;AACA,6BAAe,aAAa,EAAE,mBAAmB,EAAE;AACnD;EACE,gBAAgB;EAChB,YAAY;EACZ,WAAW;EACX,yBAAyB;EACzB,mBAAmB;EACnB,mBAAmB;EACnB,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;AACjB;AACA,qCAAsB,kBAAkB,EAAE;AAC1C,uBAAS,cAAc,EAAE,eAAe,EAAE;AAC1C;EACE,YAAY;EACZ,kDAAkD;EAClD,WAAW;EACX,gBAAgB;EAChB,eAAe;EACf,YAAY;EACZ,mBAAmB;EACnB,eAAe;EACf,4CAA4C;EAC5C,0CAA0C;AAC5C;AACA,8BAAgB,2CAA2C,EAAE;AAC7D,+BAAiB,0BAA0B,EAAE,0CAA0C,EAAE;AACzF,uBAAS,eAAe,EAAE,YAAY,EAAE,8BAA8B,EAAE,eAAe,EAAE;AACzF,yBAAW,aAAa,EAAE,oBAAoB,EAAE;AAChD,+BAAiB,yBAAyB,EAAE","sourcesContent":[".container {\r\n  max-width: 420px;\r\n  margin: 40px auto;\r\n  background: #fff;\r\n  padding: 32px 36px 40px;\r\n  border-radius: 16px;\r\n  box-shadow: 0 4px 12px rgba(0,0,0,0.08);\r\n  border: 1px solid #e5e7eb;\r\n}\r\n.title {\r\n  margin: 0 0 24px;\r\n  font-size: 24px;\r\n  font-weight: 600;\r\n  text-align: center;\r\n}\r\n.form { display: flex; flex-direction: column; gap: 18px; }\r\n.label { font-size: 14px; font-weight: 500; display: flex; flex-direction: column; gap: 6px; }\r\n.input {\r\n  height: 44px;\r\n  padding: 0 14px;\r\n  border: 1px solid #cbd5e1;\r\n  border-radius: 10px;\r\n  font-size: 15px;\r\n  transition: border-color .2s, box-shadow .2s;\r\n}\r\n.input:focus {\r\n  outline: none;\r\n  border-color: #2563eb;\r\n  box-shadow: 0 0 0 3px rgba(37,99,235,0.25);\r\n}\r\n.passwordRow { display: flex; align-items: center; }\r\n.toggleButton {\r\n  margin-left: 8px;\r\n  height: 40px;\r\n  width: 44px;\r\n  border: 1px solid #cbd5e1;\r\n  border-radius: 10px;\r\n  background: #f1f5f9;\r\n  cursor: pointer;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  font-size: 18px;\r\n}\r\n.toggleButton:hover { background:#e2e8f0; }\r\n.error { color: #dc2626; font-size: 13px; }\r\n.submit {\r\n  height: 48px;\r\n  background: linear-gradient(90deg,#2563eb,#1d4ed8);\r\n  color: #fff;\r\n  font-weight: 600;\r\n  font-size: 15px;\r\n  border: none;\r\n  border-radius: 12px;\r\n  cursor: pointer;\r\n  box-shadow: 0 4px 10px -2px rgba(0,0,0,0.15);\r\n  transition: transform .15s, box-shadow .2s;\r\n}\r\n.submit:hover { box-shadow: 0 6px 16px -2px rgba(0,0,0,0.2); }\r\n.submit:active { transform: translateY(2px); box-shadow:0 3px 8px -1px rgba(0,0,0,0.25); }\r\n.links { margin-top: 8px; display:flex; justify-content: space-between; font-size: 13px; }\r\n.links a { color:#2563eb; text-decoration:none; }\r\n.links a:hover { text-decoration:underline; }\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `SignIn_container__raUxh`,
	"title": `SignIn_title__F6fjN`,
	"form": `SignIn_form__8nGAr`,
	"label": `SignIn_label__y2V0H`,
	"input": `SignIn_input__HT8-i`,
	"passwordRow": `SignIn_passwordRow__erscc`,
	"toggleButton": `SignIn_toggleButton__V+LGd`,
	"error": `SignIn_error__RLtwJ`,
	"submit": `SignIn_submit__U1zNo`,
	"links": `SignIn_links__iXKjQ`
};
export default ___CSS_LOADER_EXPORT___;
